import { useCallback, useEffect, useState } from "react";
import { AlertTriangle, RotateCcw, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const LATE = 30000;
const KEY = "fsc_print_alerts_hidden";
const hidden = () => { try { return JSON.parse(sessionStorage.getItem(KEY) || "[]"); } catch { return []; } };

function reason(j, data, enabled) {
  if (j.status === "failed") return j.error || "falha na impressora";
  if (j.status === "expired") return "não foi impresso em 6 horas";
  if (!enabled) return "impressão direta desligada em Configurações → Impressão";
  const seen = data.central?.seen_at ? new Date(data.now) - new Date(data.central.seen_at) : Infinity;
  return seen > LATE ? "nenhum computador com o QZ Tray ligado" : "aguardando a impressora";
}

export function PrintAlerts({ enabled }) {
  const [data, setData] = useState(null);
  const [hide, setHide] = useState(hidden);
  const load = useCallback(() => api.get("/print-jobs").then((r) => setData(r.data)).catch(() => {}), []);
  useEffect(() => {
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, [load]);
  if (!data) return null;
  const now = new Date(data.now);
  const issues = data.jobs.filter((j) => j.kind === "delivery" && j.auto && !hide.includes(j.id)
    && (["failed", "expired"].includes(j.status) || (j.status === "pending" && now - new Date(j.queued_at) > LATE)));
  if (!issues.length) return null;
  const dismiss = (id) => { const n = [...hide, id].slice(-200); sessionStorage.setItem(KEY, JSON.stringify(n)); setHide(n); };
  const retry = (j) => api.post(`/print-jobs/${j.id}/retry`).then(() => { toast.success("Enviado de novo para a impressora"); load(); }).catch((e) => toast.error(errMsg(e)));
  return (
    <div className="space-y-1" data-testid="delivery-print-alerts">
      {issues.slice(0, 3).map((j) => (
        <div key={j.id} className="flex items-center gap-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-1.5 text-xs text-amber-900" data-testid={`delivery-print-alert-${j.id}`}>
          <AlertTriangle className="h-3.5 w-3.5 shrink-0" />
          <span className="min-w-0 flex-1 sm:truncate">Comprovante do {j.title.replace("Pedido delivery ", "pedido ")} não saiu: {reason(j, data, enabled)}</span>
          {j.status !== "pending" && <button type="button" onClick={() => retry(j)} className="flex shrink-0 items-center gap-1 font-semibold hover:underline" data-testid={`delivery-print-retry-${j.id}`}><RotateCcw className="h-3 w-3" />Tentar de novo</button>}
          <button type="button" onClick={() => dismiss(j.id)} className="shrink-0 rounded p-0.5 hover:bg-amber-100" aria-label="Dispensar aviso" data-testid={`delivery-print-dismiss-${j.id}`}><X className="h-3.5 w-3.5" /></button>
        </div>
      ))}
      {issues.length > 3 && <p className="px-1 text-xs text-amber-800" data-testid="delivery-print-alerts-more">+{issues.length - 3} comprovantes não impressos</p>}
    </div>
  );
}
